/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Rights_Tools_Cell_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Set {tool} explicitly" |
*
* @param {Rights_Tools_Cell_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_cell_options_label = /** @type {((inputs: Rights_Tools_Cell_Options_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Cell_Options_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.tool} explizit festlegen`)
	return /** @type {LocalizedString} */ (`Set ${i?.tool} explicitly`)
});